export interface IRequestReviewNoteEnvelope {
  requestReviewNotesDto: IRequestReviewNote[];
  requestReviewNoteCount: number;
}

export interface IRequestReviewNote {
  id: string;
  requestReviewId: string;
  noteType: string;
  note: string;
  dateCreated: Date;
  createdById: string;
  createdByName: string;
}

//interface extention for custom built items like time in a datetime
export interface IRequestReviewNoteFormValues
  extends Partial<IRequestReviewNote> {
}

//empty form model
export class RequestReviewNoteFormValues
  implements IRequestReviewNoteFormValues {
  id: string = "";
  requestReviewId: string = "";
  noteType: string = "";
  note: string = "";

  dateCreated?: Date = undefined;
  createdById: string = "";
  createdByName: string = "";

  constructor(requestReviewId?: string) {
    if (requestReviewId) {
      this.requestReviewId = requestReviewId;
    }
    Object.assign(this);
  }
}
